export function mergeCompletedSubmissions(originalSubmissions, newSubmissions) {
  const originalIds = originalSubmissions.map((s) => s.id);
  const newUniqueSubmissions = newSubmissions.filter((s) => !originalIds.includes(s.id));
  return originalSubmissions.concat(newUniqueSubmissions).sort((a, b) => {
    return a.completed_at > b.completed_at ? -1 : a.completed_at < b.completed_at ? 1 : 0;
  });
}
